<div class="feedProduct">
  <vc-like
    class="feedProduct__like"
    type="products"
    [idItem]="product.productId"
    [likeCount]="product.likesCount"
    (click)="$event.stopPropagation(); onLike(!isLiked)"
    [isLiked]="isLiked"
  ></vc-like>

  <vc-ref [anchor]="false" [resource]="product.link">
    <vc-images [url]="'/produit/' + product.image" [alt]="product.name"></vc-images>
    <div class="feedProduct__infos"></div>
    <p class="feedProduct__infos__brand vc-text-m">{{ product.brand }}</p>
    <p *ngIf="product.size" class="feedProduct__infos__supp vc-text-s">
      <span i18n="@@PRODUCT.DESCRIPTION.DETAILS.SIZE">Size: </span>
      {{ product.size }}
    </p>
    <p
      *ngIf="product.regularPrice.amountInCents"
      class="feedProduct__infos__price  feedProduct__infos__price--old vc-text-s"
    >
      {{ product.regularPrice.formatted }}
    </p>
    <p
      class="feedProduct__infos__price vc-text-s"
      [ngClass]="{'feedProduct__infos__price--new': product.regularPrice.amountInCents}"
    >
      {{ product.price.formatted }}
    </p>
  </vc-ref>
</div>
